import thunk from 'redux-thunk';

import api from './api';
import reduxActionErrorReporter from './reduxActionErrorReporter';

export const legacyMiddleware = [api, reduxActionErrorReporter, thunk];
